export default "__VITE_ASSET__765456c8__"